import React from "react";
import { Button, Modal, Message } from "semantic-ui-react";
import useCustomerReviewModal from "@common/components/hooks/customerInteractionAdmin/useCustomerReviewModal";
import SimpleDateComponent from "../shared/forms/SimpleDateComponent";
import { DATE_FORMAT } from "@common/constants/datetime";
import { getDatePart, getSevenDaysInFuture } from "../helpers/datetime";

const StatusChangeModal = () => {
  const {
    selectedCustomerStatus,
    customerStatus,
    openStatusChangeModal,
    returnDate,
    setCustomerReviewModalState,
    onSave,
  } = useCustomerReviewModal();

  if(!returnDate) {
    setCustomerReviewModalState({ returnDate: getDatePart(getSevenDaysInFuture()) });
  }

  const setReturnDate = (_, { value }) =>{
    setCustomerReviewModalState({ returnDate: value });
  }

  const onCancel = () => {
    setCustomerReviewModalState({
      openStatusChangeModal: false,
      selectedCustomerStatus: null,
    });
  };

  return (
    <Modal
      open={openStatusChangeModal}
      closeIcon
      size="tiny"
      onClose={onCancel}
    >
      <Modal.Header>Customer Status Change</Modal.Header>
      <Modal.Content>
        <p>
          Do you want to change customer status from{" "}
          <b>{customerStatus?.text}</b> to <b>{selectedCustomerStatus?.text}</b>
          ?
        </p>
        {selectedCustomerStatus?.value === "isSelfExcluded" && (
          <Message
            warning
            header='This is will NOT EXCLUDE this customer from the Bacta self-exclusion scheme!'
            content='This is for internal use only, and will only flag this customer as excluded from your own venues within Guardian Compliance. &nbsp;
            To create a MOSES self-exclusion, please navigate to the Bacta self-exclusion scheme within Guardian Compliance Mobile.'
          />
        )}
        {selectedCustomerStatus?.value === "isTakingABreak" && (
          <SimpleDateComponent
            name="returnDate"
            defaultValue={getDatePart(getSevenDaysInFuture())}
            value={getDatePart(returnDate)}
            label="Select Return Date"
            onChange={setReturnDate}
            dateFormat={DATE_FORMAT}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" floated="left" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" color="green" onClick={onSave}>
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default StatusChangeModal;
